import React, { useState } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import * as moment from "moment";
import TeamVideoResponsesPopper from "./TeamVideoResponsesPopper";
import { useDispatch } from "react-redux";
import * as timelineActions from "reteamStore/actions";

const styles = {
  teamVideo: {
    marginTop: "10px",
    margin: "5px",
  },
  video: {
    width: "100%",
    background: "#ccc",
    height: "120px",
    objectFit: "cover",
  },
  timeFilter: {
    height: "35px",
  },
  teamVideoHeader: {
    display: "flex",
    padding: "6px",
  },
  teamVideoFooter: {
    display: "flex",
    padding: "5px",
    flexDirection: "column",
    fontSize: "12px",
    position: "relative",
  },
  publishedContainer: {
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  publishButton: {
    backgroundColor: "transparent",
    cursor: "pointer",
    width: "60px",
    margin: "5px",
    border: "1px solid #575f6b80",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ teamVideo }) => {
  const classes = styles;
  const [publish, setPublish] = useState(teamVideo?.published);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const publishTeamvideo = async (teamVideo) => {
    try {
      setLoading(true);

      await TeamService.publishTeamVideo(teamVideo.id, teamVideo.team_id);

      const teamVideoCopy = { ...teamVideo };
      teamVideoCopy.published = true;

      teamVideoCopy.is_responded = true;

      teamVideoCopy.published_at = new Date();
      dispatch(timelineActions.publishPost(teamVideoCopy));

    } catch (error) {
      console.log(error);
    }
    setLoading(false);
    setPublish(true);
  };

  return (
    <div style={classes.teamVideo} key={teamVideo.id} className="sidebar-post">
      <div style={classes.cardHeader}>
        {!loading && !publish && !teamVideo.published_at && (
          <div
            style={classes.publishButton}
            onClick={publishTeamvideo.bind(this, teamVideo)}
          >
            <abbr title="Publish" style={{ height: "25px", color: "#575f6b" }}>
              <span className="material-icons" style={{ cursor: "pointer" }}>
                send
              </span>
            </abbr>
          </div>
        )}
        {loading && !publish && (
          <div style={classes.publishButton}>
            <Loader width={20} height={20} />
          </div>
        )}
      </div>
      <video
        style={classes.video}
        src={teamVideo?.media}
        alt={teamVideo?.topic}
        autoPlay={false}
        preload="metadata"
        controls={false}
      ></video>
      <div
        style={classes.teamVideoFooter}
        className="sidebar-post-content p-3 m-1"
      >
        <h6>
          {teamVideo?.published_at || publish === true
            ? "Published"
            : "Not Published"}
        </h6>
        <div className="color-light fs-12">
          {teamVideo?.published_at
            ? moment(teamVideo.published_at).format("DD/MM/YYYY HH:mm")
            : ""}
          {publish &&
            !teamVideo?.published &&
            moment().format("DD/MM/YYYY HH:mm")}
        </div>
        <p>{teamVideo?.topic}</p>
        <div>
          <TeamVideoResponsesPopper teamVideo={teamVideo} publish={publish} />
        </div>
      </div>
    </div>
  );
};
